class PlacesOfDepartureImages {
    constructor() {
        this._images = {};
    }

    getImage(name) {
        if (name in this._images)
            return this._images[name];

        return undefined;
    }

    setImage(name, value) {
        this._images[name] = value;
    }

    removeImage(name) {
        if (name in this._images)
            delete this._images[name];
    }

    clearImages() {
        this._images = {};
    }

    hasImages() {
        return Object.keys(this._images).length > 0;
    }

    hasImage(name) {
        return name in this._images;
    }
}

export default new PlacesOfDepartureImages();